import { isSuccess } from '@/context/services/type';
import { isCommonError } from '@/libs/typeguard/isError';
import {
  AdminInvoiceReportApprovalRouteResponse,
  useGetAdminInvoiceReportApprovalRouteSuspense,
} from 'ap-openapi';

export type AdminInvoiceReportApprovalRouteResult = {
  data?: AdminInvoiceReportApprovalRouteResponse;
  error?: {
    messages?: string[] | string;
    code?: string;
  };
};

export const useAdminInvoiceReportApprovalRoute = (
  reportId: string
): AdminInvoiceReportApprovalRouteResult => {
  const { data, error } = useGetAdminInvoiceReportApprovalRouteSuspense(
    reportId,
    {
      query: { queryKey: ['adminInvoiceReportApprovalRoute', reportId] },
    }
  );

  if (error) throw error;

  const body = data?.data;
  if (!isSuccess(data?.status)) {
    if (typeof body === 'object' && isCommonError(body)) {
      return {
        error: {
          messages: body?.messages,
          code: data?.status.toString(),
        },
      };
    }
    return {
      error: { messages: undefined, code: data?.status.toString() },
    };
  }

  return { data: body };
};
